<template>
	<div class="goods-form-wrapper">
		<div class="header-sidebar mb-4" slot="header">
			<h4 class="pull-left">
				{{ $t('transaction.new_transaction') }}


			</h4>
			<b-button class="pull-right close-btn" @click="cancel" type="button" variant="link"><i class="fa fa-close"></i></b-button>
			<div class="clearfix"></div>
			<hr>
		</div>
		<form>
			<b-container fluid>
				<b-form-group>
				<b-row class="my-1">
					<b-col sm="3">
						<label :for="newTransaction.comment">{{ $t('transaction.comment') }}</label>
					</b-col>
					<b-col sm="9">
						<b-form-input size="sm" id="comment"
									  v-model="newTransaction.comment"
									  name="comment"
									  autocomplete="off"
									  v-validate="validators.comment"
									  :state="checkField('comment')"
									  :placeholder="$t('transaction.comment')"
						>
						</b-form-input>

					</b-col>
				</b-row>
			</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newTransaction.type">{{ $t('transaction.type') }}</label>
						</b-col>
						<b-col sm="9">
							<b-form-select v-model="newTransaction.type"
										   v-validate="validators.type"
										   :plain="false"
										   size="sm"
										   :required="true"
										   :text-field="'name'"
										   :value-field="'id'"
										   data-errormessage-value-missing="Bu maydon to'ldirilishi shart!">

								<template slot="first">
									<option :value="null" disabled selected>
										--{{$t('transaction.type-text')}}--
									</option>
									<option value="PUL_BERILDI">{{$t('transaction.send-money')}}</option>
									<option value="PUL_OLINDI">{{$t('transaction.give-money')}}</option>
									<option value="PUL_BERISH_KERAK">{{$t('transaction.need-money')}}</option>
									<option value="PUL_OLISH_KERAK">{{$t('transaction.take-money')}}</option>
								</template>
							</b-form-select>

						</b-col>
					</b-row>
				</b-form-group>

				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newTransaction.responsibleName">{{ $t('transaction.responsibleName') }}</label>
						</b-col>
						<b-col sm="9">

							<multiselect class="pull-left with-clear" v-model="newTransaction.responsibleName"
										 :options="employees"
										 :searchable="true"
										 :loading="dropdowns.loading"
										 :close-on-select="true"
										 label="name"
										 :selectLabel="''"
										 :deselectLabel="''"
										 track-by="id"
										 :custom-label="fullName"
										 @search-change="fetchEmployees($event)"
										 :placeholder="$t('incomes.create.select-employee')"
							>

							</multiselect>

						</b-col>
					</b-row>
				</b-form-group>

				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newTransaction.contractId">{{ $t('transaction.contractId') }}</label>
						</b-col>
						<b-col sm="9">
							<b-form-select
								v-model="newTransaction.contractId"
								size="sm"

							>
								<option v-for="(selectOption, indexOpt) in dropdowns.contracts"
										:key="indexOpt"
										:value="selectOption.id"
								>
									{{ selectOption.comment }}
								</option>
								<template slot="first">
									<option :value="null" disabled>-- {{ $t('transaction.contractId')  }} --</option>
								</template>
							</b-form-select>

						</b-col>
					</b-row>
				</b-form-group>

				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newTransaction.contragentName">{{ $t('transaction.contragentName') }}</label>
						</b-col>
						<b-col sm="9">
							<b-form-select
								v-model="newTransaction.contragentName"
								size="sm"
								:placeholder="123123"

							>
								<option v-for="(selectOption, indexOpt) in dropdowns.counterparties"
										:key="indexOpt"
										:value="selectOption"
								>
									{{ selectOption.fullName }}
								</option>
								<template slot="first">
									<option :value="null" disabled>-- {{ $t('transaction.contragentName') }} --</option>
								</template>
							</b-form-select>

						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newTransaction.priceUsd">{{ $t('transaction.priceUsd') }}</label>
						</b-col>
						<b-col sm="9">
							<b-form-input size="sm" id="priceUsd"
										  v-model="newTransaction.priceUsd"
										  name="priceUsd"
										  autocomplete="off"
										  type="number"
										  v-validate="validators.priceUsd"
										  :state="checkField('priceUsd')"
										  :placeholder="$t('transaction.priceUsd')"
							>
							</b-form-input>

						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newTransaction.priceUzs">{{ $t('transaction.priceUzs') }}</label>
						</b-col>
						<b-col sm="9">
							<b-form-input size="sm" id="priceUzs"
										  v-model="newTransaction.priceUzs"
										  name="priceUzs"
										  type="number"
										  autocomplete="off"
										  v-validate="validators.priceUzs"
										  :state="checkField('priceUzs')"
										  :placeholder="$t('transaction.priceUzs')"
							>
							</b-form-input>

						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newTransaction.transactionDate">{{ $t('transaction.transactionDate') }}</label>
						</b-col>
						<b-col sm="9">
							<masked-input v-model="newTransaction.transactionDate"
										  mask="11-11-1111"
										  class="form-control form-control-sm"
							/>

						</b-col>
					</b-row>
				</b-form-group>


			</b-container>

			<div class="modal-actions">
				<b-row class="align-items-center">
					<b-col cols="6" class="mb-3 mb-xl-0">
						<b-row>
							<b-col cols="6">
								<b-button block size="sm" type="button" @click="cancel" variant="outline-danger">{{
									$t('cancel') }}
								</b-button>
							</b-col>
							<b-col cols="6">
								<b-button block type="button" size="sm" @click="create" variant="primary">{{ $t('save')
									}}
								</b-button>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</div>

		</form>
	</div>
</template>

<script>

	import {validators} from "../mixins/validators";
	import {mapActions, mapGetters} from "vuex";
	import MaskedInput from 'vue-masked-input'
	import ContrAgentService from "../../../../services/contragent.service";
	import ReferencesService from "../../../../services/references.sevice";
	import Multiselect from 'vue-multiselect'
	import EmployeeService from '../../../../services/employees.service'
	import Employees from "../mixins/Employee";
	import ContractService from "../../../../services/contract.service";

	export default {
		name: 'AddTransaction',
		props: {
			mode: {
				type: String,
				default: 'create'
			},
			edit: {
				type: Object,
				default: null
			}

		},
		mixins: [Employees,validators],
		data(){
			return {
				createTransaction: {
					comment: '',
					responsibleId: '',
					responsibleName: null,
					contractId: null,
					contragentId: '',
					contragentName:null,
					type:null,
					priceUsd: '',
					priceUzs: '',
					transactionDate: '',
				},
				dropdowns: {

					responsiblelNames: [],
					counterparties: [],

					contracts:[],
					loading: false,

				},

				childModal: false
			}
		},
		created() {
			this.loadContragents()
			this.loadContracts()
		},
		methods: {
			...mapActions('transaction',['createOrUpdateTransaction']),
			loadContragents() {
				ContrAgentService.search({
					page: 1, limit: 700
				}).then(response => {
					this.dropdowns.counterparties = response.data.items;

				})
			},
			loadContracts(){
				ContractService.search({
					page: 1, limit: 10
				}).then(response => {
					this.dropdowns.contracts = response.data.items;

				})
			},

			fullName({ firstName, lastName, middleName }) {
				return `${firstName} ${lastName} ${middleName}`;
			},
			cancel() {
				this.$emit('close', true);
			},

			async create() {

				this.$validator.validate().then(valid => {
					if (valid) {
						let transaction = {
								comment: this.newTransaction.comment,
								type: this.newTransaction.type,
								contractId: this.newTransaction.contractId,
								contragentId: this.newTransaction.contragentName.id,
								contragentName:this.newTransaction.contragentName.fullName,
								responsibleId: this.newTransaction.responsibleName.id,
								responsibleName: this.newTransaction.responsibleName.firstName + ' ' + this.newTransaction.responsibleName.lastName + ' ' + this.newTransaction.responsibleName.middleName ,
								priceUsd: this.newTransaction.priceUsd,
								priceUzs: this.newTransaction.priceUzs,
								transactionDate: this.newTransaction.transactionDate,

						}

							if(this.mode === 'edit')
								transaction.id = this.edit.id
							try {
								this.createOrUpdateTransaction(transaction)
									.then(response => {
										this.$emit('success', true);
									})
							}catch(error){
								throw error
							}


					} else {

						Object.keys(this.validationFields).some(key => {
							this.validationFields[key].touched = true;
							this.validationFields[key].dirty = true;
							this.validationFields[key].changed = true;
						});

						this.$vs.notify({
							title: this.$t('words.error'),
							text: this.$t('words.validation-error'),
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					}
				});
				return false;
			},


			/**
			 * Loadunits
			 */
			loadUnits() {

				ReferencesService.getReferenceChildren('unit').then(response => {
					this.dropdowns.units = response.data;
				})
			},
		},
		computed: {
			newTransaction() {
				if (this.mode === 'create') {
					return this.createTransaction
				} else {

					let obj = Object.assign({}, this.edit);

					let contragentName = this.dropdowns.counterparties.find(contragent =>
						contragent.id === this.edit.contragentId
					)

					let responsibleName = this.employees.find( responsible =>
						responsible.id === this.edit.responsibleId
					)


					obj.contragentName = contragentName

					obj.responsibleName = responsibleName
					return obj;
				}
			}
		},
		beforeMount() {

		},
		components: {
			MaskedInput,
			Multiselect
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped></style>
